import GapDaysCell from './gap_days_cell';

export default GapDaysCell;
